import { z } from "zod";
export const dependencyStatusSchema = z.enum(["ok", "error"]);
export const dependencyHealthSchema = z.object({
    status: dependencyStatusSchema,
    latencyMs: z.number().int().nonnegative().optional(),
    error: z.string().optional(),
});
export const healthResponseSchema = z.object({
    status: dependencyStatusSchema,
    version: z.string(),
    uptimeSeconds: z.number().int().nonnegative(),
    dependencies: z.object({
        postgres: dependencyHealthSchema,
        redis: dependencyHealthSchema,
        storage: dependencyHealthSchema,
    }),
});
export const readyResponseSchema = z.object({ status: z.enum(["ready", "not_ready"]) });
//# sourceMappingURL=health.js.map